// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Pqzn","col":"styles_col__1qIPz"};